import React from 'react'
import PropTypes from 'prop-types'
import {Text, Radio, RadioGroup, Flex, useMultiStyleConfig, Link} from '@chakra-ui/react'
import {FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import {useCustomPreferenceWithLocale} from '../../hooks/use-custom-preference'
import SanitizedHtml from '../html-sanitizer'
import {buildWarrantyName} from '../../utils/product-utils'
import {CloseIcon} from '../icons'
import StockLabel from '../stock-label'
/* import {useCustomPreferences} from '../../context/preferences' */

const WarrantySelectorModal = ({
    warrantyGroup,
    selectedVariantId,
    onVariantSelect,
    currency,
    warrantyError,
    setWarrantyError,
    isBlocked = false,
}) => {
    const styles = useMultiStyleConfig('WarrantySelectorModal', {})
    const warrantyTermsAndConditionsLink = useCustomPreferenceWithLocale(
        'warrantyTermsAndConditionsLink',
    )
    const {formatMessage} = useIntl()
    if (!warrantyGroup?.variants || warrantyGroup.variants.length === 0) {
        return null
    }
    const warrantyDescription = warrantyGroup?.warrantyDescription
        ? warrantyGroup.warrantyDescription
        : ''
    return (
        <Flex {...styles.outterContainer}>
            <Flex {...styles.container}>
                <Flex {...styles.header}>
                    <Text {...styles.title}>
                        <FormattedMessage
                            id="universal.feedback.title.extend-warranty"
                            defaultMessage="Estendi la tua garanzia con De’Longhi Care"
                        />
                    </Text>
                    <Text {...styles.description}>
                        {warrantyDescription && (
                            <SanitizedHtml html={warrantyDescription} sanitize={true} />
                        )}
                    </Text>
                    {/*                     {isBlocked && <Text> Placeholder CalloutMessage</Text>} */}
                </Flex>
                <RadioGroup
                    onChange={(value) => {
                        onVariantSelect(value)
                        setWarrantyError(false)
                    }}
                    value={selectedVariantId || ''}
                    isDisabled={isBlocked}
                >
                    <Flex {...styles.warrantiesContainer}>
                        {warrantyGroup.variants.map((variant) => {
                            const warrantyName = buildWarrantyName(
                                warrantyGroup.warrantyGroupName,
                                variant.serviceDuration,
                                formatMessage,
                            )
                            return (
                                <Flex key={variant.productId} {...styles.radioContainer}>
                                    <Radio value={variant.productId}>
                                        <Flex {...styles.itemContainer}>
                                            <Text as="span">{warrantyName}</Text>
                                            <Text {...styles.price}>
                                                <FormattedNumber
                                                    style="currency"
                                                    currency={currency}
                                                    value={variant.price || 0}
                                                />
                                            </Text>
                                        </Flex>
                                    </Radio>
                                </Flex>
                            )
                        })}
                    </Flex>
                </RadioGroup>
            </Flex>
            <Flex {...styles.termsAndConditionsContainer}>
                <Text>
                    <FormattedMessage
                        id="warranty-selector.terms-and-conditions-label"
                        defaultMessage="Per ulteriori dettagli sull'estensione di garanzia De’Longhi Care consulta i "
                    />{' '}
                    <Link
                        href={warrantyTermsAndConditionsLink}
                        isExternal
                        _hover={{textDecoration: 'none'}}
                        textDecoration="underline"
                    >
                        <FormattedMessage
                            defaultMessage="Termini e condizioni"
                            id="warranty_selector.warranty_terms_and_conditions_link"
                        />
                    </Link>
                </Text>
            </Flex>
            {/*Error message if no warranty is selected */}
            {warrantyError && (
                <Flex alignItems="center">
                    <StockLabel
                        variant={'outOfStock'}
                        icon={<CloseIcon />}
                        textMessage={
                            <FormattedMessage
                                id="warranty_selector.error_message.select_warranty"
                                defaultMessage="Seleziona un piano"
                            />
                        }
                    />
                </Flex>
            )}
        </Flex>
    )
}

WarrantySelectorModal.propTypes = {
    warrantyGroup: PropTypes.object.isRequired,
    parentProductId: PropTypes.string.isRequired,
    selectedVariantId: PropTypes.string,
    onVariantSelect: PropTypes.func.isRequired,
    currency: PropTypes.string,
    warrantyError: PropTypes.bool,
    setWarrantyError: PropTypes.func,
    isBlocked: PropTypes.bool,
}

export default WarrantySelectorModal
